/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OfferProductElectricalProtection } from '../models/OfferProductElectricalProtection';
import type { PaginatedOfferProductElectricalProtectionList } from '../models/PaginatedOfferProductElectricalProtectionList';
import type { PatchedOfferProductElectricalProtection } from '../models/PatchedOfferProductElectricalProtection';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OffersProductElectricalProtectionsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedOfferProductElectricalProtectionList
     * @throws ApiError
     */
    public offersProductElectricalProtectionsList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedOfferProductElectricalProtectionList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-electrical-protections/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns OfferProductElectricalProtection
     * @throws ApiError
     */
    public offersProductElectricalProtectionsCreate({
        requestBody,
    }: {
        requestBody: OfferProductElectricalProtection,
    }): CancelablePromise<OfferProductElectricalProtection> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/offers-product-electrical-protections/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductElectricalProtection
     * @throws ApiError
     */
    public offersProductElectricalProtectionsRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product electrical protection.
         */
        id: number,
    }): CancelablePromise<OfferProductElectricalProtection> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-electrical-protections/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OfferProductElectricalProtection
     * @throws ApiError
     */
    public offersProductElectricalProtectionsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product electrical protection.
         */
        id: number,
        requestBody: OfferProductElectricalProtection,
    }): CancelablePromise<OfferProductElectricalProtection> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/offers-product-electrical-protections/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductElectricalProtection
     * @throws ApiError
     */
    public offersProductElectricalProtectionsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product electrical protection.
         */
        id: number,
        requestBody?: PatchedOfferProductElectricalProtection,
    }): CancelablePromise<OfferProductElectricalProtection> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/offers-product-electrical-protections/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public offersProductElectricalProtectionsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product electrical protection.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/offers-product-electrical-protections/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
